import React from 'react';

import BoitageQualification from '../../components/Analyzing/BoitageQualification';

function BoitageQualificationView() {
  return (
    <BoitageQualification />
  );
}

export default BoitageQualificationView;


